module.exports = {"VUE_APP_ENVIRONMENT":"PRODUCTION","VUE_APP_PHP_API_BASE_PATH":"https://poh-api.adv-ant.ru/v1/","VUE_APP_DOTNET_API_BASE_PATH":"https://services.adv-ant.ru/api/","VUE_APP_OTP_SERVICE_BASE_PATH":"https://mfa.adv-ant.ru/v1/api/","VUE_APP_LA_API_BASE_PATH":"https://loganalyzerapi.adv-ant.ru/v1/api/logs","VUE_APP_USERSTATUS_API_BASE_PATH":"https://userstatusapi.adv-ant.ru/v1/api/"}


//////////////////
// WEBPACK FOOTER
// ./static/data/appconfig.prod.json
// module id = q8OL
// module chunks = 1